import { PermissionLevel } from './usePermissions.types';

export const EDIT_PERMISSION_LEVELS: PermissionLevel[] = [
  'full',
  'provisional',
  'restricted',
];
